









import LazyFooter from 'library/components/layout/footer/lazy-footer'

export default

	components: {
		LazyFooter
	}

